import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 14 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5C12.3807 5 13.5 3.88071 13.5 2.5C13.5 1.11929 12.3807 0 11 0C9.79052 0 8.78165 0.858887 8.55001 2H0.5C0.223854 2 0 2.22385 0 2.5C0 2.77615 0.223854 3 0.5 3H8.55001C8.78165 4.14111 9.79052 5 11 5Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgCircleWithLine = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgCircleWithLine;
